import dynamic from 'next/dynamic';
import Link from 'next/link';
import APP_CONFIG from '@lib/constants/APP_CONFIG';
import { GetServerSideProps, NextPage } from 'next';

const { EMAIL_CONTACT } = APP_CONFIG;

const Layout = dynamic(import('@lib/view/components/layoutWithFooter'));

const RefundPolicy: NextPage<{}> = () => {
    return (
        <Layout title="Refund Policy" classHeader="header-shadow">
            <div className="container px-4 md:px-35px mx-auto pt-10 pb-4 mb-10 border border-t-0">
                <div className="container mx-auto">
                    <div className="border-rouded mt-16 md:mt-0">
                        <h1 className="font-bold text-2xl md:text-30px mb-4 text-green-cyprus">
                            <Link href="/">
                                <a>Streamkick.co</a>
                            </Link>
                            &nbsp;Refund Policy
                        </h1>
                        <p className="text-sm leading-6 md:text-base text-green-cyprus leading-7">
                            Since&nbsp;
                            <Link href="/">
                                <a>www.Streamkick.co</a>
                            </Link>
                            &nbsp;is offering non-tangible irrevocable goods we
                            do not issue refunds once the order is accomplished
                            and the product is sent. As a customer, you are
                            responsible for understanding this upon purchasing
                            any item at our site.
                        </p>
                        <div className="pt-4">
                            <h2 className="text-xl mb-4 font-bold">
                                However, we realize that exceptional
                                circumstances can take place with regard to the
                                character of the product we supply.
                            </h2>
                            <h2 className="text-xl mb-4 font-bold">
                                Therefore, we DO honor requests for the refund
                                on the following reasons:
                            </h2>
                            <h2 className="text-xl mb-4 font-bold">
                                Non-delivery of the product:
                            </h2>
                            <p className="text-sm leading-6 md:text-base text-green-cyprus leading-7">
                                In some cases, the process times are slower, and
                                it may take a little longer for your orders to
                                finish. In this case, we recommend contacting us
                                for assistance. Claims for non-delivery must be
                                submitted to our support department in writing
                                within 7 days from the order placing date,
                                either via our contact form or by email:
                                <br />
                                <a href="mailto:support@streamkick.co">
                                    support@streamkick.co.
                                </a>
                                <br />
                                Otherwise, the campaign will be considered
                                completed.
                            </p>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl mb-4 font-bold">
                                Product not-as-described:
                            </h2>
                            <p className="text-sm leading-6 md:text-base text-green-cyprus leading-7">
                                Such issues should be reported to our support
                                department within 7 days from the date of the
                                purchase. Clear evidence must be provided
                                proving that the purchased product is not as it
                                is described on the website.
                                <br />
                                Complaints which are based merely on the
                                customer’s false expectations or wishes are not
                                honored.
                                <br />
                                Our support team is always eager to assist you
                                and deliver highly professional support in a
                                timely manner. Thank you for purchasing from us.
                                <br />
                                Questions about the &nbsp;
                                <Link href="/refund-policy">
                                    <a>Returns Policy.</a>
                                </Link>
                                &nbsp; should be sent to us at &nbsp;
                                <a href={`mailto:${EMAIL_CONTACT}`}>
                                    {EMAIL_CONTACT}
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default RefundPolicy;

export const getServerSideProps: GetServerSideProps = async (): Promise<{
    props: { title: string };
}> => {
    return {
        props: {
            title: 'Refund Policy',
        },
    };
};
